import React, { useEffect } from "react";
import Product from "../components/Product";
import { useDispatch, useSelector } from "react-redux";
import { productList } from "../redux/slices/productSlice";
import { BsArrowRightCircle } from "react-icons/bs";
import { Link } from "react-router-dom";
import { motion } from "framer-motion"; // You'll need to install framer-motion

const LatestProducts = () => {
  const { data, loading } = useSelector((state) => state.products);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(
      productList({
        name: "",
        category: "",
      })
    );
  }, [dispatch]);

  // Get latest 4 products
  const latestProducts = data?.slice(0, 3) || [];

  if (loading) {
    return (
      <div className="flex justify-center items-center  py-[30px]">
        <div className="relative w-20 h-20">
          <div className="absolute top-0 left-0 w-full h-full border-4 border-gray-200 rounded-full"></div>
          <div className="absolute top-0 left-0 w-full h-full border-4 border-t-amber-400 border-r-transparent border-b-transparent border-l-transparent rounded-full animate-spin"></div>
        </div>
      </div>
    );
  }

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
  };

  return (
    <section className="bg-gradient-to-b from-white to-gray-50  py-[30px]">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Section header with View All link */}
        <div className="flex flex-wrap justify-between items-center mb-12">
          <motion.div
            className="relative"
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <h2 className="text-2xl sm:text-3xl font-bold text-gray-900">
              Ən son əlavə olunanlar
            </h2>
            <div className="absolute -bottom-2 left-0 w-24 h-1.5 bg-gradient-to-r from-amber-400 to-amber-500 rounded-full"></div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5 }}
          >
            <Link
              to="/allproducts"
              className="group inline-flex items-center bg-blue-50 hover:bg-blue-100 text-blue-600 hover:text-blue-700 font-medium text-sm sm:text-base px-5 py-2.5 rounded-full transition-all"
            >
              Hamısına bax
              <BsArrowRightCircle className="ml-2 group-hover:translate-x-1 transition-transform" />
            </Link>
          </motion.div>
        </div>

        {/* Products grid with responsive columns */}
        {latestProducts.length > 0 ? (
          <motion.div
            className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {latestProducts.map((product) => (
              <motion.div
                key={product?._id}
                variants={{
                  hidden: { opacity: 0, y: 20 },
                  visible: { opacity: 1, y: 0 },
                }}
              >
                <Product product={product} newProducts={latestProducts} />
              </motion.div>
            ))}
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="text-center py-16 bg-white rounded-lg shadow-sm"
          >
            <div className="flex flex-col items-center">
              <svg
                className="w-16 h-16 text-gray-300 mb-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <p className="text-gray-500 text-lg">Məhsul tapılmadı</p>
            </div>
          </motion.div>
        )}
      </div>
    </section>
  );
};

export default LatestProducts;
